import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingDairyPrimaryDataById, getFootprintingDairyPrimaryDataByIdAdmin } from "services";

import { getEnvironment, shouldRetryQueryError } from "utils";

import { FOOTPRINTING_DAIRY_PRIMARY_DATA } from "consts";

export const useGetFootprintingDairyPrimaryDataById = (primaryDataId: string, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useQuery(
    {
      queryKey: [FOOTPRINTING_DAIRY_PRIMARY_DATA, primaryDataId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingDairyPrimaryDataByIdAdmin(primaryDataId) : getFootprintingDairyPrimaryDataById(primaryDataId)),
      enabled: enabled && !!primaryDataId,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
